import { saveAudioBlob, deleteAudioBlob } from '../audioStorage';
import sendAudioData from '../audioUpload';

let savingDisabled = false;

export async function handleChunkDataAvailable(e, {
  audioMimeType,
  sessionUuid,
  currentChunkIndex,
  setTotalChunks,
}) {
  if (!e.data || e.data.size === 0) return currentChunkIndex;

  const blob = e.data instanceof Blob ? e.data : new Blob([e.data], { type: audioMimeType });
  if (!blob || blob.size === 0) return currentChunkIndex;

  const chunkData = { sessionUuid, chunkIndex: currentChunkIndex, blob };

  console.log(`Saving chunkIndex=${currentChunkIndex}, sessionUuid=${sessionUuid}`);

  if (!savingDisabled) {
    try {
      await saveAudioBlob(chunkData);
    } catch (error) {
      console.error('❌ Error saving audio blob in localDB. Disabling saving.', error);
      savingDisabled = true;
    }
  }

  const success = await sendAudioData(chunkData);
  if (success) {
    console.log(`✅ Chunk index ${currentChunkIndex} uploaded successfully`);

    if (!savingDisabled) {
      console.log(`🧹 Deleting uploaded chunk index ${currentChunkIndex}`);
      await deleteAudioBlob(sessionUuid, currentChunkIndex);
    }
  } else {
    console.log(`❌ Failed to upload chunk index ${currentChunkIndex}`);
  }

  const nextChunkIndex = currentChunkIndex + 1;
  console.log(`📊 Setting totalChunks to ${nextChunkIndex}`);
  setTotalChunks(nextChunkIndex);

  return nextChunkIndex;
}